import axios from 'axios'
import { getUpdatePerfilUsuario } from './getUpdateUser';

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})

export async function postUpdatePerson(first_name, last_name, address, contact, dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/account/updatepersoncomplement',
        {
            "first_name": first_name,
            "last_name": last_name,
            "address": {
                "name": address.logradouro,
                "complement": address.complemento,
                "neighborhood": address.bairro,
                "cep": address.cep,
                "number": address.numero,
                "city": {
                    "code": address.ibge,
                    "state": {
                        "uf": address.uf
                    }
                }
            },
            "contact": {
                "telephone": contact.numTelefone,
                "cellphone": contact.numCelular
            }
        },
        {
            headers: {
                'Authorization': AuthToken
            }
        }).then(response => {
            successPostUpdatePerson(response, dispatch);
        }).catch(erro => {
            erroPostUpdatePerson(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

async function successPostUpdatePerson(response, dispatch) {
    if (response.status === 200) {
        localStorage.setItem(process.env.REACT_APP_TOKENUSER, response.data.token);
        await getUpdatePerfilUsuario(dispatch);

        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Alterar dados',
            description: 'Dados alterados com sucesso'
        })
    }
}

function erroPostUpdatePerson(erro, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Alterar dados',
        description: 'Houve um erro ao tentar enviar os dados'
    })
}